import { ERRORE_ASR, ERRORE_BLOCKING, ERRORE_DATI_ERRATI, ERRORE_GENERICO_POSTLOGIN, ERRORE_PAZIENTE_NON_TROVATO, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED } from "./messaggioLabels";

export const PATIENT_NOT_FOUND_OUT_AGE_RANGE = "Attenzione: la campagna di screening è riservata agli assistiti con una età compresa tra i 50 e 74 anni.";

export const PATIENT_NOT_FOUND_IN_AGE_RANGE = "Attenzione: il tuo nominativo non risulta essere presente nella banca dati del Servizio di Prevenzione.";

export const switchBackToSaluteSimplex = (status) => {
    switch (status) {
        case ERRORE_ASR:
        case ERRORE_PAZIENTE_NON_TROVATO:
        case ERRORE_DATI_ERRATI:
        case ERRORE_GENERICO_POSTLOGIN:
        case ERRORE_UNAUTHORIZED:
        case ERRORE_SESSION_EXPIRED:
        case ERRORE_BLOCKING:
            return true
        default:
            return false
    }

}